import React from 'react';
import {Link} from "react-router-dom";

/**
 *
 * @param {string} [className]
 * @param {boolean} [isDisabled]
 * @param {React.ReactNode} children
 * @param {import("react-router-dom").LinkProps} linkProps
 */
export default function PolLinkButton({className = "btn-primary", isDisabled, children, ...linkProps}) {

    return (
        <Link className={`btn ${className} ${isDisabled ? 'disabled' : ''}`}
              {...linkProps}>
            {children}
        </Link>
    )
}
